/**
 * @description 将函数包装成要求浏览器在下次重绘之前调用该回调函数
 * @param action
 * @returns
 */
const animationFrame = <T>(action: T): any => {
  let stop = false;

  return (...params: any[]): void => {
    if (!stop) {
      stop = true;
      requestAnimationFrame(() => {
        if (typeof action === 'function') {
          action(...params);
        }
        stop = false;
      });
    }
  };
};

export default animationFrame;
